class StorageService {
  constructor($window) {
    let storageType = 'sessionStorage';
    this.prefix = 'JPMC';
    this.storage = $window[storageType];
  }
  prefixKey(key) {
    return this.prefix + '.' + key;
  }
  setItem(key, value) {
    if (typeof value === 'undefined') {
      value = null;
    } else {
      value = JSON.stringify(value);
    }
    this.storage.setItem(this.prefixKey(key), value);
  }
  getItem(key) {
    let item = this.storage.getItem(this.prefixKey(key));
    if (!item || item === 'null') {
      return null;
    }
    try {
      return JSON.parse(item);
    } catch(err) {
      return item;
    }
  }
  removeItem(key) {
    this.storage.removeItem(this.prefixKey(key));
  }
  clearStorage() {
    this.storage.clear();
  }
}

StorageService.$inject = ['$window'];

export default StorageService;



// WEBPACK FOOTER //
// ./src/services/storage.service.js